"use strict";

export function getHttpStatusString(httpResp: ng.IHttpPromiseCallbackArg<any>) {
    return (httpResp) ? `Status - (${ httpResp.status }) ${ httpResp.statusText }\r\n` : "";
}

export function getHttpErrorDetails(httpResp: ng.IHttpPromiseCallbackArg<any>) {
    let errorDetails = "";
    if (httpResp && httpResp.data) {
        errorDetails = getHttpStatusString(httpResp);
        if (typeof httpResp.data === "string") {
            const contentType = httpResp.headers ? httpResp.headers("content-type") : null;
            if (contentType != null && contentType.indexOf("text/html") < 0) { // don't need to display HTML error page.
                errorDetails += httpResp.data;
            }
        } else {
            for (const key in httpResp.data) {
                if (httpResp.data.hasOwnProperty(key)) {
                    let propVal = httpResp.data[key];
                    if ( (!!propVal) && ( Array.isArray(propVal) || (propVal.constructor === Object))) {
                        propVal = JSON.stringify(propVal, null, "\t");
                    }
                    errorDetails += `${key} : ${propVal}\r\n`;
                }
            }
        }
    }
    return errorDetails;
}

export function getOrderApiErrorDetails(httpResp: ng.IHttpPromiseCallbackArg<any>) {
    let errorDetails = "";
    if (httpResp != null) {
        if (httpResp.data != null) {
            if (httpResp.status === 406) {
                errorDetails = httpResp.data;
            } else if (typeof httpResp.data === "object") {
                // Todo: should display API error instead of Thirdy party API error message.
                if (httpResp.data.orderNumber) {
                    errorDetails += `${httpResp.data.orderNumber}:`;
                }
                if (httpResp.data.errorNumber) {
                    errorDetails += `(${httpResp.data.errorNumber})`;
                }
                if (httpResp.data.errorMessage) {
                    errorDetails += ` ${httpResp.data.errorMessage}`;
                }
            } else {
                errorDetails = "There was an error processing your request. Please try again later";
            }
        }

        if (!errorDetails) {
            errorDetails = getHttpStatusString(httpResp);
        }
    }
    return errorDetails;
}
